import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 从CDN引入，不导入。 import './plugins/element.js'
import './assets/css/global.css'
import TreeTable from 'vue-table-with-tree-grid'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import axios from 'axios';
axios.defaults.baseURL = '../server/api/private/v1/';
// axios拦截request
axios.interceptors.request.use(config => {
  NProgress.start();
  config.headers.Authorization = window.sessionStorage.getItem('vue_shop_admin-token');
  return config;
});
// axios拦截response
axios.interceptors.response.use(config => {
  NProgress.done();
  return config;
});
Vue.prototype.$http = axios;

Vue.config.productionTip = false

Vue.component('TreeTable', TreeTable)

Vue.use(VueQuillEditor)

Vue.filter('dateFormat', function (timestamp) {
  const date = new Date(timestamp * 1000);
  const y = date.getFullYear();
  const m = (date.getMonth() + 101).toString().slice(1);
  const d = (date.getDate() + 100).toString().slice(1);
  const hh = (date.getHours() + 100).toString().slice(1);
  const mm = (date.getMinutes() + 100).toString().slice(1);
  const ss = (date.getSeconds() + 100).toString().slice(1);
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})

window.myapp = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

console.log('main-prod.js console.log')
console.warn('main-prod.js console.warn')
